const COLLECTION = "user_logs_flat";

const processDocs = (docs) => {
  const data = [];
  docs.forEach((doc) => {
    const elem = doc.data();
    elem.id = doc.id;
    data.push(elem);
  });
  return data;
};

function UserLogsFlatMixin(firebase) {
  return {
    /**
     * Gets all user logs flat that match a certain field and value.
     *
     * @param {Object} params - The parameters for the query.
     * @param {string} params.field - The field to match.
     * @param {string} params.value - The value to match.
     * @returns {Promise<Array<Object>>} The matching user logs flat.
     */
    async getAllByField({ field, value }) {
      return this.collection(COLLECTION)
        .where(`${field}`, "==", value)
        .get()
        .then((querySnapshot) => processDocs(querySnapshot));
    },

    /**
     * Creates a new user log flat in Firebase.
     *
     * @param {Object} params - The parameters for the new user log flat.
     * @param {Object} params.meta - Metadata associated with the log.
     * @param {string} params.roleId - The ID of the role associated with the user.
     * @param {string} params.roleName - The name of the role associated with the user.
     * @param {string} params.type - The type of the log.
     * @param {string} params.userId - The ID of the user.
     * @param {string} params.userName - The name of the user.
     * @param {string} params.orgaName - The name of the organization.
     * @param {string} params.orgaId - The Id of the organization.
     * @param {string} params.originatorUserId - The id of the user who performed the action.
     * @param {string} params.originatorUserName - The name of the user who performed the action.
     * @param {string} params.message - The log message.
     * @returns {Promise<Object>} The created user log flat.
     */
    async createUserLogFlat({
      meta,
      roleId,
      roleName,
      type,
      userId,
      userName,
      orgaName,
      orgaId,
      originatorUserId,
      originatorUserName,
      message
    }) {
      const createdDateServerTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      const dataToSave = {
        meta,
        roleId,
        roleName,
        type,
        userId,
        userName,
        orgaName,
        orgaId,
        originatorUserId,
        originatorUserName,
        message,
        createdDate: createdDateServerTimestamp
      };
      const ref = await this.collection(COLLECTION).add(dataToSave);
      const createUserLogsFlatData = {
        id: ref.id,
        ...dataToSave
      };
      return createUserLogsFlatData;
    }
  };
}

module.exports = UserLogsFlatMixin;
